export default __webpack_public_path__ + "static/bunker-fonts-mobile-3b3aec03cad4f072304709a8c41cd280.jpg";